module.exports = __webpack_public_path__ + "assets/img/5.ca7613d0.svg";